export const subsListFrontPath = "/subscription";
export const subsListBackPath = "/backend/subscription/";

export const subsActivateFrontPath = "/subscription/activate";
export const subsActivateBackendPath = "/backend/subscription/activate/";

export const subsActivateInquiryFrontPath = '/subscription/activate/:id';
export const subsActivateConfirmFrontPath = '/subscription/activate/confirm/:id';

export const subsExtendInquiryFrontPath = '/subscription/extend/:id';
export const subsExtendInquiryBackPath = '/backend/subscription/extend/';
export const subsExtendConfirmFrontPath = '/subscription/extend/confirm/:id';
export const subsExtendConfirmBackPath = '/backend/subscription/extend/confirm/';

export const subsEditInquiryFrontPath = '/subscription/edit/:id';
export const subsEditInquiryBackPath = '/backend/subscription/edit/';
export const subsEditConfirmFrontPath = '/subscription/edit/confirm/:id';
export const subsEditConfirmBackPath = '/backend/subscription/edit/confirm/';

export const subsShopRevokeFrontPath = '/subscription/shop/revoke/:id';
export const subsShopRevokeBackPath = '/backend/subscription/shop/revoke/';

export const orderListFrontPath = '/subscription-order';
export const orderListBackPath = '/backend/subscription/order/';

export const paymentListFrontPath = '/subscription-order/payment/';
export const paymentListBackPath = '/backend/subscription-order/payment/';

export const paymentDetailFrontPath = '/subscription-order/payment/detail/:id';
export const paymentDetailBackPath = '/backend/subscription/order/payment/detail/';

export const freeTrialListFrontPath = '/free-trial/';
export const freeTrialListBackPath = '/backend/free_trial/';

export const freeTrialEditFrontPath = '/free-trial/extend/:id';
export const freeTrialDetailBackPath = '/backend/free_trial/detail/';
export const freeTrialEditBackPath = '/backend/free_trial/extend/';


// WEBPACK FOOTER //
// ./src/routes/subscription/urls.js